import { ref } from 'vue'
import type { ToggleStatus } from './events'

export function toToggleStatus(value: boolean): ToggleStatus {
  return value ? 'Enabled' : 'Disabled'
}

export interface AnalyticsProvider {
  track(event: string, properties?: Record<string, unknown>): void
  identify(userId: string, properties?: Record<string, unknown>): void
  reset(): void
}

type ContextGetter = () => Record<string, unknown>

let _provider: AnalyticsProvider | null = null
let _getContext: ContextGetter = () => ({})
const _pageName = ref('')

export function initAnalytics(provider: AnalyticsProvider, getContext: ContextGetter): void {
  _provider = provider
  _getContext = getContext
}

export function setPageName(name: string): void {
  _pageName.value = name
}

export function useAnalytics() {
  function identify(userId: string, properties?: Record<string, unknown>): void {
    _provider?.identify(userId, properties)
  }

  function track(event: string, properties?: Record<string, unknown>): void {
    if (!_provider) return
    _provider.track(event, { ..._getContext(), pageName: _pageName.value, ...properties })
  }

  function reset(): void {
    _provider?.reset()
  }

  return { track, identify, reset }
}
